module.exports = __webpack_public_path__ + "static/media/white-power-supply.75ebbbfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/white-power-supply.svg
// module id = 310
// module chunks = 0